module.exports = __webpack_public_path__ + "static/media/baba.05cda6ea.jpg";